import { req } from '../../@api/request';

export default class CouponService {
  static list = async (
    status: string,
    page: number,
    type?: string,
    planId?: number,
  ) => {
    const result = await req.get(
      `/coupon/list?status=${status}&page=${page}${type ? `&type=${type}` : ''}${planId ? `&planId=${planId}` : ''}`,
    );
    return result.data;
  };

  static detail = async (couponHistoryId: number) => {
    const result = await req.get(`/coupon/list/${couponHistoryId}`);
    return result.data;
  };

  static apply = async (couponHistoryId: number) => {
    const result = await req.post(`/coupon/apply/${couponHistoryId}`, {});
    return result.data;
  };

  static register = async (couponId: number) => {
    const result = await req.post(`/coupon/register/${couponId}`, {});
    return result.data;
  };

  static check = async (couponId: number) => {
    const result = await req.post(`/coupon/check/${couponId}`, {});
    return result.data;
  };

  static used = async (couponId: number) => {
    const result = await req.get(`/coupon/check/used/${couponId}`);
    return result.data;
  };

  static registerCode = async (couponCode: string) => {
    const result = await req.post(`/coupon/register/code/${couponCode}`, {});
    return result.data;
  };

  static randomList = async () => {
    const result = await req.get('/coupon/random/list');
    return result.data;
  };

  static random = async () => {
    const result = await req.post('/coupon/random', {});
    return result.data;
  };

  static checkRandom = async () => {
    const result = await req.get('/coupon/random');
    return result.data;
  };
}
